const AnalyticsData = {
    sales: [
      {
        month: 'January',
        product: 'Aspirin',
        unitsSold: 1000,
        pricePerUnit: 5,
        totalSales: 5000,
      },
      {
        month: 'February',
        product: 'Paracetamol',
        unitsSold: 800,
        pricePerUnit: 3,
        totalSales: 2400,
      },
      {
        month: 'March',
        product: 'Ibuprofen',
        unitsSold: 1200,
        pricePerUnit: 4,
        totalSales: 4800,
      },
      {
        month: 'April',
        product: 'Paracetamol',
        unitsSold: 1000,
        pricePerUnit: 3,
        totalSales: 3000,
      },
      {
        month: 'May',
        product: 'Aspirin',
        unitsSold: 1500,
        pricePerUnit: 5,
        totalSales: 7500,
      },
      {
        month: 'June',
        product: 'Ibuprofen',
        unitsSold: 1300,
        pricePerUnit: 4,
        totalSales: 5200,
      },
  
      // Weekly Data (for January)
      {
        week: 'Week 1',
        product: 'Aspirin',
        unitsSold: 250,
        pricePerUnit: 5,
        totalSales: 1250,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        unitsSold: 250,
        pricePerUnit: 5,
        totalSales: 1250,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        unitsSold: 250,
        pricePerUnit: 5,
        totalSales: 1250,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        unitsSold: 250,
        pricePerUnit: 5,
        totalSales: 1250,
      },
  
      // Weekly Data (for February)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        unitsSold: 200,
        pricePerUnit: 3,
        totalSales: 600,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        unitsSold: 200,
        pricePerUnit: 3,
        totalSales: 600,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        unitsSold: 200,
        pricePerUnit: 3,
        totalSales: 600,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        unitsSold: 200,
        pricePerUnit: 3,
        totalSales: 600,
      },
  
      // Weekly Data (for March)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        unitsSold: 300,
        pricePerUnit: 4,
        totalSales: 1200,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        unitsSold: 300,
        pricePerUnit: 4,
        totalSales: 1200,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        unitsSold: 300,
        pricePerUnit: 4,
        totalSales: 1200,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        unitsSold: 300,
        pricePerUnit: 4,
        totalSales: 1200,
      },
  
      // Weekly Data (for April)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        unitsSold: 250,
        pricePerUnit: 3,
        totalSales: 750,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        unitsSold: 250,
        pricePerUnit: 3,
        totalSales: 750,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        unitsSold: 250,
        pricePerUnit: 3,
        totalSales: 750,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        unitsSold: 250,
        pricePerUnit: 3,
        totalSales: 750,
      },
  
      // Weekly Data (for May)
      {
        week: 'Week 1',
        product: 'Aspirin',
        unitsSold: 375,
        pricePerUnit: 5,
        totalSales: 1875,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        unitsSold: 375,
        pricePerUnit: 5,
        totalSales: 1875,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        unitsSold: 375,
        pricePerUnit: 5,
        totalSales: 1875,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        unitsSold: 375,
        pricePerUnit: 5,
        totalSales: 1875,
      },
  
      // Weekly Data (for June)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        unitsSold: 325,
        pricePerUnit: 4,
        totalSales: 1300,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        unitsSold: 325,
        pricePerUnit: 4,
        totalSales: 1300,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        unitsSold: 325,
        pricePerUnit: 4,
        totalSales: 1300,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        unitsSold: 325,
        pricePerUnit: 4,
        totalSales: 1300,
      },
    ],
  
    revenue: [
      // Monthly Data
      {
        month: 'January',
        product: 'Aspirin',
        revenue: 5000,
      },
      {
        month: 'February',
        product: 'Paracetamol',
        revenue: 2400,
      },
      {
        month: 'March',
        product: 'Ibuprofen',
        revenue: 4800,
      },
      {
        month: 'April',
        product: 'Paracetamol',
        revenue: 3000,
      },
      {
        month: 'May',
        product: 'Aspirin',
        revenue: 7500,
      },
      {
        month: 'June',
        product: 'Ibuprofen',
        revenue: 5200,
      },
  
      // Weekly Data (for January)
      {
        week: 'Week 1',
        product: 'Aspirin',
        revenue: 1250,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        revenue: 1250,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        revenue: 1250,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        revenue: 1250,
      },
  
      // Weekly Data (for February)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        revenue: 600,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        revenue: 600,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        revenue: 600,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        revenue: 600,
      },
  
      // Weekly Data (for March)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        revenue: 1200,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        revenue: 1200,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        revenue: 1200,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        revenue: 1200,
      },
  
      // Weekly Data (for April)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        revenue: 750,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        revenue: 750,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        revenue: 750,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        revenue: 750,
      },
  
      // Weekly Data (for May)
      {
        week: 'Week 1',
        product: 'Aspirin',
        revenue: 1875,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        revenue: 1875,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        revenue: 1875,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        revenue: 1875,
      },
  
      // Weekly Data (for June)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        revenue: 1300,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        revenue: 1300,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        revenue: 1300,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        revenue: 1300,
      },
    ],
  
    expenses: [
      // Monthly Data
      {
        month: 'January',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 2000,
      },
      {
        month: 'February',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 1200,
      },
      {
        month: 'March',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 2640,
      },
      {
        month: 'April',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 1500,
      },
      {
        month: 'May',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 3000,
      },
      {
        month: 'June',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 2860,
      },
  
      // Weekly Data (for January)
      {
        week: 'Week 1',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 500,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 500,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 500,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 500,
      },
  
      // Weekly Data (for February)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 300,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 300,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 300,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 300,
      },
  
      // Weekly Data (for March)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 660,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 660,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 660,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 660,
      },
  
      // Weekly Data (for April)
      {
        week: 'Week 1',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 375,
      },
      {
        week: 'Week 2',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 375,
      },
      {
        week: 'Week 3',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 375,
      },
      {
        week: 'Week 4',
        product: 'Paracetamol',
        costPerUnit: 1.5,
        totalCost: 375,
      },
  
      // Weekly Data (for May)
      {
        week: 'Week 1',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 750,
      },
      {
        week: 'Week 2',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 750,
      },
      {
        week: 'Week 3',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 750,
      },
      {
        week: 'Week 4',
        product: 'Aspirin',
        costPerUnit: 2,
        totalCost: 750,
      },
  
      // Weekly Data (for June)
      {
        week: 'Week 1',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 715,
      },
      {
        week: 'Week 2',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 715,
      },
      {
        week: 'Week 3',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 715,
      },
      {
        week: 'Week 4',
        product: 'Ibuprofen',
        costPerUnit: 2.2,
        totalCost: 715,
      },
    ],
  };
  
  export default AnalyticsData;
  